import React, { useState, useEffect, useRef, useContext } from "react";
import { FaEdit, FaSave, FaSearch, FaTimes, FaTrash } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../utils/AxiosInstance";
import { AppContext } from "../context/AppContext";
import Select from "react-select";
import { useDebounce } from "../utils/usedebounce";
import Pagination from "../widgets/Pagination";
import { useMediaQuery } from "@mui/material";
import { useMsal } from "@azure/msal-react";
import ConfirmationModalInput from "../widgets/ConfrimationModalInput";
import ConfirmationModalRlsMail from "../widgets/ConfirmationModalRlsMail";
import ConfirmationModalDeleteMail from "../widgets/ConfirmationModalDeleteMail";

const SegUserManagement = ({refreshKey,SegditUserId,setSegEditUserId,setCurrentPageSeg,currentPageSeg}) => {
  const [Segusers, setSegusers] = useState([]);

  const [editFormData, setEditFormData] = useState({});
  const inputRefs = useRef({});
  const [rolesOptions, setRole] = useState([]); 
  const [totalRecords, setTotalRecords] = useState(0);
  const [prevSearchTerm, setPrevSearchTerm] = useState();
  const isSmallScreen = useMediaQuery("(max-width:600px)");
  const { instance } = useMsal();
  const account = instance.getActiveAccount();
  const normalizedAccountEmail = account?.username?.trim().toLowerCase();

  const {
    setLoader,
    loader,
    setToast,
    confirmationModalInput,
    setConfirmationModalInput,
    confirmationModalDeleteMail,
    setConfirmationModalDeleteMail,
    roles,
    setRoles,
    setApplicationOption,
    setSelectedRoles,
    ApplicationOption,
    setSelectapplication,
    selectedRoles,
    selectapplication,
    setConfirmationModalRlsMail,
    confirmationModalRlsMail,
    fetchUrlInReport,setfetchUrlInReport,segSearchTerm, setSegSearchTerm,
  } = useContext(AppContext);

  const onPageChange = (page) => {
    setCurrentPageSeg(page);
  };

  const fetchRoles = async () => {
    try {
      setLoader(true);
      const response = await axiosInstance.get("/rolesSeg");
      console.log(response,'fetchRoles')
      if (response.data) {
        setRole(
          response.data?.data?.map((item) => ({
            value: item._id,
            label: item.roleName,
          }))
        );
      }
      // setLoader(false);
    } catch (error) {
      setLoader(false);
      console.error("Error fetching roles:", error);
    }
  };
  const fetchUsers = async (page) => {
    try {
      const response = await axiosInstance.get(
        `/getAlluserSeg${page ? "?page=" + page : ""}`,
        {}
      );
    //   setSegusers(response.data);
      setSegusers(response.data);
      setTotalRecords(response.data.totalRecords); // Set the total number of users
      setCurrentPageSeg(response.data.currentPage);
      setTimeout(() => {
        setLoader(false);
      }, 2000);
    } catch (error) {
      console.error("Error fetching users:", error);
      setLoader(false);
    }
  };
  const handleSearch = async ({ segSearchTerm, page }) => {
    const cleanTerm = segSearchTerm.trim();
    setLoader(true);
    setSegusers([]);
    setTotalRecords();
    setCurrentPageSeg(currentPageSeg);
    try {
      const response = await axiosInstance.post(
        `/findUserBySearchSeg?searchTerm=${cleanTerm}&page=${page}`
      );
      if (response.status == 200) {
        setPrevSearchTerm(cleanTerm);
        setLoader(false);
        setSegusers({
          users: response.data.users.map((item) => {
            return {
              ...item,
              role: item.role.map((role) => {
                return {
                  label: role,
                  value: role,
                };
              }),
            };
          }),
        });
        setTotalRecords(response.data.totalRecords);
        setCurrentPageSeg(response.data.currentPage);
      }
    } catch (error) {
      setLoader(false);
      console.error("Error fetching users:", error);
    }
  };

  const debouncedSearchTerm = useDebounce(segSearchTerm?.trim(), 700); // 500ms debounce

  useEffect(() => {
    if (debouncedSearchTerm) {
      if (prevSearchTerm !== segSearchTerm) {
         setCurrentPageSeg(1); 
        handleSearch({ segSearchTerm: segSearchTerm, page: 1 });
      } else {
   handleSearch({ segSearchTerm: segSearchTerm, page: currentPageSeg });
      }
    } else {
      setLoader(true);
      fetchUsers(currentPageSeg);
      fetchRoles();
    }
  }, [debouncedSearchTerm, currentPageSeg]);


  const handleSave = async (userId, userMail,userName) => {
   const originalUser = Segusers.users.find((user) => user.mail === SegditUserId);
const originalRoles = originalUser?.role?.map((role) => role.label) || [];

const newRoles = selectedRoles
  ? (Array.isArray(selectedRoles)
      ? selectedRoles.map((r) => r.label)
      : [selectedRoles.label])
  : [];

const haveRolesChanged =
  JSON.stringify([...originalRoles].sort()) !== JSON.stringify([...newRoles].sort());

console.log("rolechanged", originalRoles, newRoles);

let exists;


// if (originalRoles.includes("Viewer") && !newRoles.includes("Viewer")) {
//   exists = await check_rlsExistance(userMail);
// }


    if (!exists) {
      continuehandleSave(userId,userName);
    } else {
      console.log("itemInElse", userId);
      setConfirmationModalRlsMail({ mail: userMail, userId: userId, show: true });
    }
  };

  const deleteRlsLinked = async (email) => {
    setLoader(true);
    try {
      const response = await axiosInstance.delete("/delete-rls-mail", {
        data: { email: email },
      });

      if (response.status === 200) {
        // setLoader(false);
        console.log("delte data", response.data);
        setConfirmationModalRlsMail({
          show: false,
          mail: "",
          userId: "",
        });
      }
    } catch (error) {
      setLoader(false);

      console.error("Error deleting report card:", error);
    }
  };

const deleteReportCardRls = async (mail, userId) => {
    // await deleteRlsLinked(mail);
    await deleteAdUser(userId)
  };
const deleteReportCardRlsUpdate = async (mail, userId) => {
    // await deleteRlsLinked(mail);
    await continuehandleSave(userId,mail);
  };
 const check_rlsExistance = async (mail) => {
    setLoader(true);
    try {
      const response = await axiosInstance.post("/check-rls-mail", {
        email:mail,
      });
      console.log("response For the existence", response.data);

      return response?.data?.exists;
    } catch (error) {
      console.error("Error fetching roles:", error);
      return false;
    } finally {
      setLoader(false);
    }
  };
  const continuehandleSave = async (userId,userName) => {
    const originalUser = Segusers.users.find((user) => user.mail === SegditUserId);
    const originalRoles = originalUser?.role?.map((role) => role.label) || [];
    const newRoles =
      selectedRoles && selectedRoles.label ? [selectedRoles.label] : [];

    const originalApplications = originalUser?.ID || [];
    const isFirstNameChanged =
      editFormData?.first_name !== originalUser?.displayName;
    const isEmailChanged =
      editFormData?.invitedUserEmailAddress !== originalUser?.mail;

    // Check if roles have changed (compare arrays)
    const haveRolesChanged =
      JSON.stringify(originalRoles.sort()) !== JSON.stringify(newRoles.sort());

    if (
      !isFirstNameChanged &&
      !isEmailChanged &&
      !haveRolesChanged
      // !haveApplicationsChanged
    ) {
      setToast({ show: true, type: "info", message: "No changes were made." });
      setSegEditUserId(null)
      setConfirmationModalRlsMail({
        show: false,
        id: "",
        userId: "",
      });
      return;
    }

    setLoader(true);

    const body = {
      userId,
      updates: {
        ...editFormData,
        role: newRoles,
        last_name: "", // You might want to handle this differently if `last_name` is a real field
      },
    };

    try {
      const response = await axiosInstance.post(`/updateUserSeg`, body);
      console.log(body,"body")
      if (response.status === 200) {
        setSegSearchTerm("");
        setLoader(true);
          fetchUsers(currentPageSeg);
        //  fetchUserApplications(userName)
        setToast({
          show: true,
          type: "success",
          message: "User updated successfully",
        });
        setConfirmationModalRlsMail({
          show: false,
          id: "",
          userId: "",
        });
        setSegEditUserId(null);
      } else {
        setToast({
          show: true,
          type: "error",
          message: "An unexpected error occurred",
        });
        setConfirmationModalRlsMail({
          show: false,
          id: "",
          userId: "",
        });
        setSegEditUserId(null);
      }
    } catch (error) {
      setToast({ show: true, type: "info", message: "Something went wrong" });
      console.error("Error updating user:", error);
    } finally {
      setLoader(false);
      setConfirmationModalRlsMail({
        show: false,
        id: "",
        userId: "",
      });
    }
  };

  const handleCancelEdit = () => {
    setSegEditUserId(null);
    setEditFormData({});
    setSelectedRoles([]);
    setSelectapplication([]);
    setToast({
      show: true,
      type: "success",
      message: "No changes were made",
    });
  };

  const continueDelete = async (id,email) => {
// const exists = await check_rlsExistance(email);
      deleteAdUser(id);

    // if (!exists) {
    // } else {
    //   setConfirmationModalDeleteMail({ mail: email, userId: id, show: true });
      
    // }
  }

 const  deleteAdUser = async (id)=>{
 
 
    try {
      const response = await axiosInstance.post(`/deleteUserAdSeg`, { id: id });
      if (response.status === 200) {
        setLoader(true);
       await fetchUsers(1);
        setToast({
          show: true,
          type: "success",
          message: "User deleted successfully",
        });
         setSegusers((prev) => ({
        ...prev,
        users: prev.users.filter((user) => user.id !== id),
      }));
        setSegSearchTerm("");
        setCurrentPageSeg(1);
         setConfirmationModalDeleteMail({ mail: '', userId: '', show: false });
      } else {
        setToast({
          show: true,
          type: "error",
          message: "An unexpected error occurred",
        });
      }
    } catch (error) {
      setToast({ show: true, type: "info", message: "No changes were made." });
      console.error("Error updating user:", error);
    } finally {
      setConfirmationModalInput({id:"",show:false})
      setLoader(false);
    }
 
  }


useEffect(()=>{
console.log(Segusers,'Segusers')
},[Segusers])
  return (
    <div className="flex flex-col h-full relative">
     
      {confirmationModalInput?.show && (
        <ConfirmationModalInput
          onDelete={() => continueDelete(confirmationModalInput.id,confirmationModalInput.email)}
          isOpen={confirmationModalInput.show}
          onClose={() => setConfirmationModalInput({ id: "", show: false })}
          title="Enter Super Admin Password to Confirm Deletion"
        />
      )}
{/* Update   */}
      {confirmationModalRlsMail?.show && (
        <ConfirmationModalRlsMail
          onUpdate={() => continuehandleSave(confirmationModalRlsMail?.userId,confirmationModalRlsMail?.mail)}
          onDeleteRls={() =>
            deleteReportCardRlsUpdate(
              confirmationModalRlsMail?.mail,
              confirmationModalRlsMail?.userId
            )
          }
          isOpen={confirmationModalRlsMail}
          onClose={() =>
            setConfirmationModalRlsMail({
              show: false,
              mail: "",
              userId: "",
            })
          }
          title={
            "There is RLS or Reports/Applications associated with this User. Please select one option to proceed."
          }
        />
      )}
{/* delete */}
      {confirmationModalDeleteMail?.show && (
        <ConfirmationModalDeleteMail
          // onUpdate={() => deleteAdUser(confirmationModalDeleteMail.userId)}
          onDeleteRls={() =>
            deleteReportCardRls(
              confirmationModalDeleteMail?.mail,
              confirmationModalDeleteMail?.userId
            )
          }
          isOpen={confirmationModalDeleteMail}
          onClose={() =>
            setConfirmationModalDeleteMail({
              show: false,
              mail: "",
              userId: "",
            })
          }
          title={
            "All RLS and assigned reports related to this user will be removed."
          }
        />
      )}
         <div className="w-full">
        <table
          key={refreshKey}
          className="w-full table-auto rounded-lg  border-2 border-gray-300"
          // className={`w-full table-auto ${
          //   users?.users?.length > 5 ? "h-full" : ""
          // } bg-white rounded-lg shadow-md border-2 border-gray-300`}
        >
          <thead className="bg-gray-200">
            <tr className="text-left sm:text-[14px] text-[11px]  font-semibold text-gray-700 border-b border-gray-300">
              <th className="px-2 py-1 border-r border-gray-300 text-center">
                User Name
              </th>
              <th className="px-2 py-1 border-r border-gray-300 text-center">
                Email
              </th>
              <th className="px-2 py-1 border-r border-gray-300 text-center">
                Role
              </th>
              <th className="px-2 py-1 text-center">Actions</th>
            </tr>
          </thead>
          <tbody>
            {Segusers?.users?.filter((user) => user?.mail).length ? (
              Segusers.users
                .filter((user) => user.mail)
                .map((user) => (
                  <tr
                    key={user.id}
                    className="border-b border-gray-300  sm:text-[12px] text-[10px] text-gray-700"
                  >
                    {SegditUserId === user.mail ? (
                      <>
                        <td className="px-2 py-1 border-r border-gray-300 text-center">
                          <input
                            ref={(el) =>
                              (inputRefs.current[`first_name-${user.id}`] = el)
                            }
                            type="text"
                            value={
                              editFormData.first_name || user.displayName || ""
                            }
                            onChange={(e) =>
                              setEditFormData({
                                ...editFormData,
                                first_name: e.target.value,
                              })
                            }
                            onKeyDown={(e) =>
                              e.key === "Tab" &&
                              inputRefs.current[`email-${user.id}`]?.focus()
                            }
                            className="px-2 rounded w-full outline-none text-center"
                          />
                        </td>
                        <td className="px-2 border-r border-gray-300 text-center">
                          <input
                            ref={(el) =>
                              (inputRefs.current[`email-${user.id}`] = el)
                            }
                            type="text"
                            value={
                              editFormData.invitedUserEmailAddress ||
                              user.mail ||
                              ""
                            }
                            onChange={(e) =>
                              setEditFormData({
                                ...editFormData,
                                invitedUserEmailAddress: e.target.value,
                              })
                            }
                            onKeyDown={(e) =>
                              e.key === "Tab" &&
                              inputRefs.current[`role-${user.id}`]?.focus()
                            }
                            className="px-2 rounded w-full outline-none text-center"
                          />
                        </td>
                        <td className="px-2 max-w-[200px] border-r border-gray-300 text-center">
                          <Select
                            ref={(el) =>
                              (inputRefs.current[`role-${user.id}`] = el)
                            }
                            id="role"
                            value={selectedRoles}
                            onChange={(selected) => setSelectedRoles(selected)}
                            options={rolesOptions}
                            className="mt-1"
                            isClearable={true}
                            menuPortalTarget={document.body}
                            menuPlacement="auto"
                             isDisabled={user.mail === normalizedAccountEmail}
 
                            menuShouldScrollIntoView={false}
                            styles={{
                              menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                              menuList: (provided) => ({
                                ...provided,
                                maxHeight: isSmallScreen ? "80px" : "150px",
                                overflowY: "auto",
                                fontSize: isSmallScreen ? "10px" : "14px",
                              }),
                            }}
                            required
                          />
                        </td>
                        <td className="px-2 text-center">
                          <div className="flex gap-2 justify-center">
                            <button
                              onClick={() => handleSave(user.id, user?.mail, normalizedAccountEmail)}
                              className="text-green-600 hover:text-green-800"
                            >
                              <FaSave />
                            </button>
                            <button
                              onClick={handleCancelEdit}
                              className="text-gray-600 cursor-pointer"
                            >
                              <FaTimes />
                            </button>
                          </div>
                        </td>
                      </>
                    ) : (
                      <>
                        <td className="px-2 td-1920 td-1520 td-1000 td-2220 py-2.5 border-r min-w-[70px] border-gray-300 text-center ">
                          {user.displayName}
                        </td>
                        <td className="px-2 py-2.5 border-r min-w-[70px] border-gray-300 text-center">
                          {user.mail}
                        </td>
                        <td className="px-2 py-2.5 border-r min-w-[150px] border-gray-300 text-center">
                          {user.role?.length
                            ? user.role.map((item) => item.label).join(",")
                            : "-"}
                        </td>
                       
                        <td className="px-2 py-2.5 text-center">
                         <button
                  onClick={() => {
                    if (user?.mail === normalizedAccountEmail) {
                      setSegEditUserId(user.mail);
                      setEditFormData({
                        first_name: user.displayName,
                        invitedUserEmailAddress: user.mail,
                      });
                      setSelectedRoles(
                        user?.role.length > 0
                          ? user?.role?.map((role) => ({
                              value: role.value,
                              label: role.label,
                            }))
                          : []
                      );
                     
                    } else {
                      setSegEditUserId(user.mail);
                      setEditFormData({
                        first_name: user.displayName,
                        invitedUserEmailAddress: user.mail,
                      });
                      setSelectedRoles(
                        user?.role.length > 0
                          ? user?.role?.map((role) => ({
                              value: role.value,
                              label: role.label,
                            }))
                          : []
                      );
                    }
                  }}
                  className="text-blue-600 hover:text-blue-800 mr-2"
                >
                  <FaEdit />
                  </button>
                          <button
                            onClick={() => {
                              if (user?.mail === normalizedAccountEmail) {
                                setToast({
                                  show: true,
                                  type: "error",
                                  message: "Admins cannot delete their user",
                                });

                                return;
                              }
                              setConfirmationModalInput({
                                id: user?.id,
                                email: user?.mail,
                                show: true,
                              });
                            }}
                            className="mr-2"
                          >
                            <FaTrash className="cursor-pointer text-red-600" />
                          </button>
                        </td>
                      </>
                    )}
                  </tr>
                ))
            ) : (
              <tr>
                <td
                  colSpan={4}
                  className="text-center sm:text-[14px] text-[10px] py-4 text-gray-500 font-semibold"
                >
                  {loader ? "Loading..." : "Users Not Found"}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {Segusers?.users?.length > 0 && (
        <div className="w-full absolute bottom-0 flex justify-end mt-2">
          <Pagination
            totalItems={totalRecords}
            itemsPerPage={10}
            currentPage={currentPageSeg}
            onPageChange={onPageChange}
          />
        </div>
      )}
    </div>
  );
};

export default SegUserManagement;
